import script from "./SkewedDivOld.vue?vue&type=script&setup=true&lang=js"
export * from "./SkewedDivOld.vue?vue&type=script&setup=true&lang=js"

import "./SkewedDivOld.vue?vue&type=style&index=0&id=0d0796be&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d0796be"]])

export default __exports__